export default __webpack_public_path__ + "static/media/KOD0130-min.65efd7b5.webp";